import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=4e620e2d"
import script from "./preferences.vue?vue&type=script&lang=js"
export * from "./preferences.vue?vue&type=script&lang=js"
import style0 from "./preferences.vue?vue&type=style&index=0&id=4e620e2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports